<template>
  <div class="resources" :class="{ 'resources--big': big }">
    <div v-for="r in POOLS" :key="r.key" class="resource" :title="r.label">
      <!-- eslint-disable-next-line vue/no-v-html -- constant art from resourceArt.js -->
      <svg class="resource__icon" viewBox="0 0 16 16" aria-hidden="true" :style="{ color: art(r.key).colour }" v-html="art(r.key).art" />
      <span class="resource__value">{{ civ[r.key] }}</span>
      <span class="resource__label">{{ r.key === 'food' && eats !== null ? `food · eats ${eats} tonight` : r.key === 'happiness' && wants && wants.n ? `happiness · wants ${wants.n} ${wants.kind}` : r.label }}</span>
    </div>
    <div class="resource resource--divider" aria-hidden="true" />
    <div v-for="t in TRACKS" :key="t.key" class="resource resource--track" :class="[trackClass(t), { 'resource--tap': t.key === 'threat' }]" :title="t.label" @click.stop="t.key === 'threat' && $emit('explain', t.key)">
      <!-- eslint-disable-next-line vue/no-v-html -- constant art from resourceArt.js -->
      <svg class="resource__icon" viewBox="0 0 16 16" aria-hidden="true" :style="{ color: art(t.key).colour }" v-html="art(t.key).art" />
      <span class="resource__value">{{ civ[t.key] }}<span class="resource__max">/{{ maxOf(t) }}</span></span>
      <span class="resource__label">{{ t.key === 'population' ? 'people · homes' : t.label }}{{ t.key === 'threat' && big ? ' ⓘ' : '' }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
import { HAPPINESS_MAX, THREAT_MAX, POPULATION_MAX } from '@/engine/constants';
import { housingOf } from '@/engine/effects';
import { RESOURCES } from './resourceArt';

// The table's numbers, in the SAME eight glyphs the phones and the cards
// use. Matt, 2026-09-20: "make sure that the TV screen and the common
// screens also adopt the lessons that we've learned." This strip was the
// one place left in the game drawing resources as emoji, so a Steward
// asking for "two goods" saw a drawn crate on the phone and a box emoji on
// the television. House style rule 6: a number never travels without its
// thing, and its thing is always the same shape.
export const POOLS = [
  { key: 'food', label: 'food' },
  { key: 'goods', label: 'goods' },
  { key: 'coin', label: 'coin' },
  { key: 'knowledge', label: 'knowledge' },
  { key: 'workers', label: 'workers' },
];

export const TRACKS = [
  { key: 'population', label: 'people', max: POPULATION_MAX },
  { key: 'happiness', label: 'happiness', max: HAPPINESS_MAX, lowIsBad: true },
  { key: 'threat', label: 'threat', max: THREAT_MAX, highIsBad: true },
];

export default {
  name: 'ResourceStrip',
  emits: ['explain'],
  props: {
    civ: { type: Object, required: true },
    big: { type: Boolean, default: false },
    // Food the town will eat tonight (playtest 7: "we might need 2 or 3
    // food, I'm not sure. That would be a good thing to be able to clearly see").
    eats: { type: Number, default: null },
    // What the people want tonight ({ n, kind }), beside happiness (after playtest 12).
    wants: { type: Object, default: null },
  },
  data() { return { POOLS, TRACKS }; },
  methods: {
    art(key) { return RESOURCES[key] || RESOURCES.goods; },
    // People are out of the homes the town has (housing), not a fixed 12.
    maxOf(t) { return t.key === 'population' ? housingOf(this.civ) : t.max; },
    trackClass(t) {
      const v = this.civ[t.key];
      if (t.lowIsBad && v <= 3) return 'resource--bad';
      if (t.highIsBad && v >= 7) return 'resource--bad';
      if (t.key === 'population' && v >= housingOf(this.civ)) return 'resource--full';
      return '';
    },
  },
};
</script>
